<script setup>
import { getActivePinia, } from 'pinia'
import CodeBlock from '@/assets/js/src/modules/webmasters/_components/CodeBlock.vue'
import { useWebmasterStore, } from '@/assets/js/src/modules/webmasters/_pinia/webmasters'
import { ref, } from 'vue'
import { useTranslation, } from '@/assets/js/src/util/composables'

const loading = ref(false)
const key = ref('')
const domain = ref('')
const { t, } = useTranslation()

const webmasterStore = useWebmasterStore(getActivePinia())
        
const loadApiKey = async  function () {
    if (domain.value.trim() !== '' && domain.value.trim() !== 'https://') {
        loading.value = true
        try {
            let response = await webmasterStore.fetchApiKey(domain.value)

            key.value = response.api_key
            domain.value = response.domain
        } catch {
            key.value = ''
        } finally {
            loading.value = false
        }
    }
}
</script>

<template>
    <div id="apikey">
        <h2 class="mt-5 mb-2">
            {{ t('async.webmasters.api_key.heading') }}
        </h2>
        <div v-html="t('async.webmasters.api_key.text')"></div>
        <transition
            name="fade"
            mode="out-in"
        >
            <div
                v-if="key.trim() === ''"
                role="form"
            >
                <v-row
                    no-gutters
                    wrap
                >
                    <v-col
                        cols="12"
                        sm="8"
                    >
                        <v-text-field
                            v-model="domain"
                            :label="t('async.webmasters.api_key.label.input')"
                            bg-color="background"
                            @keypress.enter="loadApiKey"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="4"
                    >
                        <v-btn
                            color="primary"
                            :loading="loading"
                            :disabled="loading"
                            :title="t('async.webmasters.api_key.label.button')"
                            @click="loadApiKey"
                            @keypress.enter="loadApiKey"
                        >
                            {{ t('async.webmasters.api_key.label.button') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
            <div v-else>
                <p>{{ t('async.webmasters.api_key.result',{domain:domain,}) }}</p>
                <code-block
                    :code="key"
                    language="Text"
                ></code-block>
            </div>
        </transition>
        <div v-html="t('async.webmasters.api_key.hint')"></div>
    </div>
</template>
